"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ExpandButton = _interopRequireDefault(require("../ExpandButton"));
var _Input = _interopRequireDefault(require("../Input"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Hooks = require("../Hooks");
var _styled = require("./styled");
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const TimeRangePicker = _ref => {
  let {
    fontSize = '12px',
    height = 40,
    icon = 'add',
    margin = '0px',
    onPick = () => null,
    onValidate = () => true,
    width = 'auto'
  } = _ref;
  const [error, setError] = (0, _react.useState)(false);
  const [values,, setValue] = (0, _Hooks.useObjectState)({
    timeFrom: '',
    timeTo: ''
  });
  const {
    timeFrom,
    timeTo
  } = values;
  const handleAdd = () => {
    if (validate()) {
      onPick(timeFrom, timeTo);
    }
  };
  const handleTimeChange = (id, value) => {
    setError(false);
    setValue(id, value);
  };
  const validate = () => {
    if (!timeFrom || !timeTo || timeTo <= timeFrom || !onValidate(timeFrom, timeTo)) {
      setError(true);
      return false;
    }
    setError(false);
    return true;
  };
  const buttonProps = {
    icon
  };
  const containerProps = {
    error,
    height,
    margin,
    width
  };
  const inputProps = {
    error,
    fontSize,
    height: "".concat(height - 15, "px"),
    marginBottom: '0px',
    padding: '0px 0px 0px 5px',
    type: 'time',
    width: '90px'
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.default, _objectSpread(_objectSpread({}, inputProps), {}, {
      value: timeFrom,
      onChange: value => handleTimeChange('timeFrom', value)
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Separator, {
      children: "-"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Input.default, _objectSpread(_objectSpread({}, inputProps), {}, {
      value: timeTo,
      onChange: value => handleTimeChange('timeTo', value)
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandButton.default, _objectSpread(_objectSpread({}, buttonProps), {}, {
      circle: true,
      danger: error,
      margin: "0px 0px 0px 5px",
      size: 20,
      onClick: handleAdd
    }))]
  }));
};
TimeRangePicker.propTypes = {
  fontSize: _propTypes.default.string,
  height: _propTypes.default.number,
  icon: _propTypes.default.string,
  margin: _propTypes.default.string,
  onPick: _propTypes.default.func,
  onValidate: _propTypes.default.func,
  width: _propTypes.default.string
};
var _default = exports.default = TimeRangePicker;